import * as actionTypes from '../Register_action.types';

const initialState = {
  loggingIn: false,
  other_inputs: [],
  error: null,
  message: '',
};

const OtherInputs = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_OTHER_INPUTS_REQUEST:
    case actionTypes.DELETE_OTHER_INPUTS_REQUEST:
    case actionTypes.UPLOAD_OTHER_INPUTS_REQUEST:
    case actionTypes.MULTIDELETE_OTHER_INPUTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actionTypes.UPDATE_OTHER_INPUTS_SUCCESS:
    case actionTypes.DELETE_OTHER_INPUTS_SUCCESS:
    case actionTypes.UPLOAD_OTHER_INPUTS_SUCCESS:
    case actionTypes.MULTIDELETE_OTHER_INPUTS_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.payload,
      };
    case actionTypes.GET_OTHER_INPUTS_SUCCESS:
      return {
        ...state,
        loading: false,
        other_inputs: action.payload,

      }
    case actionTypes.GET_OTHER_INPUTS_FAILURE:
    case actionTypes.UPDATE_OTHER_INPUTS_FAILURE:
    case actionTypes.DELETE_OTHER_INPUTS_FAILURE:
    case actionTypes.UPLOAD_OTHER_INPUTS_FAILURE:
    case actionTypes.MULTIDELETE_OTHER_INPUTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default OtherInputs
